import { render, staticRenderFns } from "./android.vue?vue&type=template&id=a31782cc&scoped=true&"
import script from "./android.vue?vue&type=script&lang=js&"
export * from "./android.vue?vue&type=script&lang=js&"
import style0 from "./android.vue?vue&type=style&index=0&id=a31782cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31782cc",
  null
  
)

export default component.exports